import { BaseService } from 'core/services';
import WoundOrderRouteService from './WoundOrderRouteService';

class WoundOrderService extends BaseService {
    constructor(apiClient) {
        super(apiClient, new WoundOrderRouteService());
    }
}

export default WoundOrderService;
